import { render, staticRenderFns } from "./AuthBottomNav.vue?vue&type=template&id=780aa23c&"
import script from "./AuthBottomNav.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AuthBottomNav.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports